import { render } from "./PageWaiter.vue?vue&type=template&id=1de6ea43"
import script from "./PageWaiter.vue?vue&type=script&lang=js"
export * from "./PageWaiter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__